import { render, staticRenderFns } from "./AppsumoSettings.vue?vue&type=template&id=fadb27e0"
import script from "./AppsumoSettings.vue?vue&type=script&lang=js"
export * from "./AppsumoSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fadb27e0')) {
      api.createRecord('fadb27e0', component.options)
    } else {
      api.reload('fadb27e0', component.options)
    }
    module.hot.accept("./AppsumoSettings.vue?vue&type=template&id=fadb27e0", function () {
      api.rerender('fadb27e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/account-page/appsumo-settings/AppsumoSettings.vue"
export default component.exports